export default "__VITE_ASSET__DsDhr00T__"